<template>
  <ColumnWithHelp
    sortable
    :resizable="false"
    width="130"
    :title="$t('ADVERTISEMENT.SEARCH_TERMS.INSTALL_PRICE_COLUMN')"
    :content="$t('ADVERTISEMENT.SEARCH_TERMS.INSTALL_PRICE_COLUMN_DESCRIPTION')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { installCost } }">
      {{ priceFormat(installCost) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'SearchTermInstallPriceColumn',
  components: {
    ColumnWithHelp,
  },
  inheritAttrs: false,
  methods: {
    priceFormat,
  },
};
</script>
